export const version = {
  version: 'v3.6',
};
